module.exports = __webpack_public_path__ + "static/media/promed-logo.0cf0db31.png";